export interface IAddress {
    recipientName?: string;
    streetAddress: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  }